<template>
  <v-app class="app-guest">
    <TheAlert />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import TheAlert from '@/components/TheAlert.vue'

@Component({ components: { TheAlert }})
export default class Guest extends Vue {
}
</script>
